import { Theme } from "common";

export const buttonStyle = {
  margin: "2px 5px",
};

export const templatesConfigStyles = {
  root: {
    backgroundColor: Theme.palette.background.paper,
  },
  tempHeading: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: Theme.palette.grey[700],
    color: Theme.palette.common.white,
    fontSize: "15px",
    padding: "5px 10px",
  },
  editor: {
    width: "800px",
    "& .ProseMirror a": {
      "&:hover": {
        cursor: "pointer",
      },
    },
  },
  templatesConfigRoot: {
    width: "100%",
    margin: "0 auto 0 auto",
  },
  studyTableHead: {
    backgroundColor: "#666666",
  },
};
